export default __webpack_public_path__ + "static/media/misc-bathtubA-1024w.f38c6038.avif";